<template>
    <div class="container">
        <content-header title="Стерилизация медицинских изделий"/>
        <p style="font-size: 16px; text-indent: 30px">
            <span class="bold">Центральное стерилизационное отделение</span> предлагает отлаженный технологический
            процесс паровой стерилизации инструментария хирургического, косметологического, стоматологического,
            гинекологического, оториноларингологического профилей, а также белья и перевязочного материала.
        </p>
        <p style="font-size: 16px; text-indent: 30px">
            В процессе обработки мы гарантируем максимальный уровень эффективности стерилизационного процесса
            обеззараживаемых изделий с применением современного оборудования, новейший упаковочных материалов, таких как
            <span class="bold">SteriClin, Клинипак</span>, в том числе длительного срока хранения.
        </p>
        <p><strong>По вопросам сотрудничества обращаться к Кузнецовой Анне Михайловне.</strong></p>
        <p><strong>✉ kuznetsova.a@5-clinic.ru</strong>
            <a href="tel:+74956208112" class="link">☏ 8 (495) 620-81-12</a>
            <a href="tel:+79037158035" class="link">☏ 8 (903) 715-80-35</a>
        </p>
        <div class="inv-divider"></div>
        <div class="flex center">
            <img src="../../assets/images/staticPages/pdf-icon-png-2068-75x75.png" alt="pdf-icon" width="75"
                 height="75">
            <a href="/static/files/staticContent/Прейскурант-ЦСО.pdf" target="_blank" class="link left-30px">Прейскурант ЦСО</a>
        </div>
        <div class="inv-divider"></div>
        <div class="inv-divider"></div>
        <h3>Наше стерилизационное оборудование</h3>
        <div class="inv-divider"></div>
        <div class="flex">
            <img src="../../assets/images/staticPages/strl1.jpg" alt="strl1" width="310" height="495">
            <img src="../../assets/images/staticPages/strl3.jpg" alt="strl3" width="310" height="551">
            <img src="../../assets/images/staticPages/strl2.jpg" alt="strl2" width="310" height="470">
        </div>
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";

export default {
    name: "sterilization",
    components: {
        ContentHeader
    },
}

</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

h3 {
    font-size: 18px;
    margin: 0;
    padding: 0;
    font-weight: normal;
    color: #000;
}

h3:after {
    content: "";
    display: block;
    bottom: 0;
    width: 50px;
    height: 2px;
    background: #00b6cc;
    margin-top: 10px
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
}

.flex.center {
    align-items: center;
}

.link {
    color: #006688;
    border-bottom: 1px dotted #006688;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
}

.left-30px {
    margin-left: 30px;
}

</style>
